<template>
  <transition name="vr360-spinner">
    <div v-if="spinner.show" class="vr360-flex-column vr360-spinner vr360-spinner--fixed">
      <img class="vr360-spinner__img" src="@/assets/img/app/loader.png" alt>
      <p class="vr360-head-h2">{{ spinner.title }}</p>
      <p>{{ spinner.subtitle }}</p>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Spinner",
  computed: {
    ...mapGetters({
      spinner: "spinner"
    })
  }
};
</script>

<style lang="scss">
</style>
